/**
 * PURPOSE: Centralizar textos/formatos de presentación del panel de Comunicados.
 * RESPONSIBILITIES: Traducir status/pushStatus a etiquetas en español que nunca insinúen entrega
 *   humana ("Entregado", "Visto", "Recibido") — sólo lo que el backend realmente prueba
 *   (aceptación por Expo) — y formatear fechas/tamaños de archivo de forma consistente.
 * COLLABORATORS: HayllisCommunicationsList.jsx, HayllisCommunicationDetailReadOnly.jsx,
 *   HayllisPublishConfirmModal.jsx.
 * ROUTE: winscore/src/admin/HayllisCommunications/hayllisCommunicationsDisplay.utils.js
 */

export const STATUS_LABELS = {
  DRAFT: "Borrador",
  PUBLISHED: "Publicado",
};

// Deliberately never "Entregado"/"Visto"/"Recibido" — a push accepted by Expo is not proof a
// device or a human ever saw it (FTR-0005 §17/§19).
export const PUSH_STATUS_LABELS = {
  NOT_SENT: "Sin enviar",
  SENDING: "Procesando envío",
  SENT: "Envío procesado",
  PARTIAL: "Envío con errores",
  FAILED: "Error de envío",
};

export const ATTACHMENT_TYPE_LABELS = {
  "application/pdf": "PDF",
  "image/jpeg": "Imagen JPG",
  "image/png": "Imagen PNG",
  "image/webp": "Imagen WEBP",
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("es-PE", {
    timeZone: "America/Lima",
    dateStyle: "medium",
    timeStyle: "short",
  });
};

export const formatBytes = (bytes) => {
  const value = Number(bytes);
  if (!value || value <= 0) return "";
  const kb = value / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

export const buildPushSummary = (notification) => {
  const counters = notification?.counters || { targeted: 0, accepted: 0, failed: 0 };
  return `Destinatarios: ${counters.targeted} · Aceptados por Expo: ${counters.accepted} · Errores: ${counters.failed}`;
};
